import React from 'react';

// Adds the fade-in-up class once the element scrolls into view.
export default function useFadeInOnScroll() {
  const ref = React.useRef();
  React.useEffect(() => {
    const node = ref.current;
    if (!node) return;
    const observer = new window.IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          node.classList.add('fade-in-up');
          observer.unobserve(node);
        }
      },
      { threshold: 0.1 }
    );
    observer.observe(node);
    return () => observer.disconnect();
  }, []);
  return ref;
}
